export const SET_PROJECT_REPORT_METRICS = 'SET_PROJECT_REPORT_METRICS';
export const SET_PROJECT_REPORTS = 'SET_PROJECT_REPORTS';
export const SET_PHOTOS = 'SET_PHOTOS';
export const SET_SHARED_ALBUMS = 'SET_SHARED_ALBUMS';
export const SET_SHARED_FOLDERS = 'SET_SHARED_FOLDERS';
export const SET_LOADED = 'SET_LOADED';
